import { useEffect } from 'react';
import { httpsCallable } from 'firebase/functions';
import { useDispatch } from 'react-redux';
import { functions } from './firebase.config';
import { setAccessToken } from './redux/slices/uspsSlice';
import './App.css';
import Layout from './components/Layout/Layout';

function App() {
    const dispatch = useDispatch();

    useEffect(() => {
        const hasSeeded = sessionStorage.getItem('superAdminSeeded');
        if (!hasSeeded) {
            const seedSuperAdmin = httpsCallable(functions, 'seedSuperAdmin');
            seedSuperAdmin()
                .then(() => {
                    sessionStorage.setItem('superAdminSeeded', 'true');
                })
                .catch(() => {});
        }

        const loadUSPSAccessToken = async () => {
            const token = localStorage.getItem('uspsAccessToken');
            const expiry = localStorage.getItem('uspsTokenExpiry');

            // If no token or token has expired
            if (!token || !expiry || Date.now() > Number(expiry)) {
                try {
                    const getAccessToken = httpsCallable(functions, 'getAccessToken');
                    const response = await getAccessToken();
                    const newToken = response.data?.accessToken;

                    if (newToken) {
                        const expiresAt = Date.now() + 8 * 60 * 60 * 1000; // 8 hours
                        localStorage.setItem('uspsAccessToken', newToken);
                        localStorage.setItem('uspsTokenExpiry', expiresAt.toString());
                        dispatch(setAccessToken(newToken));
                    }
                } catch (error) {
                    console.error('Failed to fetch USPS token:', error);
                }
            } else {
                dispatch(setAccessToken(token));
            }
        };

        loadUSPSAccessToken();
    }, [dispatch]);

    return <Layout />;
}

export default App;
